import { render, staticRenderFns } from "./a23.vue?vue&type=template&id=497a3f30&scoped=true&"
import script from "./a23.vue?vue&type=script&lang=js&"
export * from "./a23.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497a3f30",
  null
  
)

export default component.exports